module.exports = __webpack_public_path__ + "static/media/sample_Triangel.85e06fde.mp3";